import BaseFilters from './BaseFilters';
import DateFilter from './DateFilter';
import EnvironmentFilter from './EnvironmentFilter';
import IsActiveFilter from './IsActiveFilter';
import ProcessFilter from './ProcessFilter';
import UserFilter from './UserFilter';

export { FILTER_FIELD_SIZES } from './filterFieldSizes';
export { buildAuditFilters } from './auditFilters';

const Filters = {
  UserFilter,
  ProcessFilter,
  DateFilter,
  EnvironmentFilter,
  IsActiveFilter,
  BaseFilters,
};

// Filter configurations registry for global access
export const FilterConfigRegistry = {};

// Register filter configurations that have special properties
Object.keys(Filters).forEach((key) => {
  const filter = Filters[key];
  if (filter?.name) {
    FilterConfigRegistry[filter.name] = filter;
  }
});

// Helper function to register module-specific filters
export const registerModuleFilters = (moduleNamespace, filters) => {
  if (!FilterConfigRegistry[moduleNamespace]) {
    FilterConfigRegistry[moduleNamespace] = {};
  }

  filters.forEach((filter) => {
    if (filter.name) {
      FilterConfigRegistry[moduleNamespace][filter.name] = filter;
    }
  });
};

export default Filters;
